import { render, staticRenderFns } from "./substituteDrivingDispatch.vue?vue&type=template&id=0990112a&scoped=true&"
import script from "./substituteDrivingDispatch.vue?vue&type=script&lang=js&"
export * from "./substituteDrivingDispatch.vue?vue&type=script&lang=js&"
import style0 from "./substituteDrivingDispatch.vue?vue&type=style&index=0&id=0990112a&scoped=true&lang=css&"
import style1 from "./substituteDrivingDispatch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0990112a",
  null
  
)

export default component.exports